<template lang="pug">
Box.track-order-form
  h3 Track Your Order
  .form-description
    | Track your Rogue Order from the moment we receive it to the moment you get it.
    | To track an order, enter the order number and email used when your order was placed.
  TrackOrderForm
</template>

<script setup lang="ts">
import TrackOrderForm from 'Src/js/pages/rss/components/track-order-form.vue'
</script>

<style scoped lang="scss">
.box {
  margin: $app-gap-default;
}
.box {
  border: $border-width-thin solid $color-gray-light
}
.form-description {
  font-size: $size-xs;
  line-height: $line-height-l;
  margin-bottom: $space-m;
}
</style>
